<template>
  <div class="store_one">
    <div @click="selectStore" class="store_one_btn">
      {{ storeName }}
    </div>

    <el-dialog
      :visible.sync="visible"
      title="选择门店"
      width="800px"
      class="store_one_dialog"
      :before-close="changeCancel"
    >
      <div class="dialog" v-loading="loading">
        <div class="dialog_left">
          <div class="dialog_left_header">
            <el-input
              @keyup.enter.native="changeSearch"
              v-model="input"
              class="dialog_left_header_input"
              style="height: 28px; padding: 10px 0 0 10px"
              placeholder="搜索"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="changeSearch"
              ></i></el-input>
          </div>
          <div class="dialog_left_content">
            <el-tree
              :data="areaTreeData"
              accordion
              node-key="id"
              ref="tree"
              :props="defaultProps"
              @node-click="selectArea"
              :expand-on-click-node="false"
              default-expand-all
              :default-checked-keys="defaultStaff"
            >
              <span
                :class="['custom-tree-node',data.id === selectNodeId ? 'selected' : '']"
                slot-scope="{ node, data }"
                @click="showEmplist(node, data)"
              >
                <span>
                  {{ data.name }}
                </span>
              </span>
            </el-tree>
          </div>
          
        </div>
        <div class="dialog_right">
          <div class="dialog_right_header">
            <el-select
              v-model="value"
              class="serch_input"
              placeholder="门店类型"
              multiple
              collapse-tags
              size="mini"
              @change="changeType"
            >
              <el-option
                v-for="item in options"
                :key="item.valueOne"
                :label="item.name"
                :value="item.valueOne"
              >
              </el-option>
            </el-select>

            <el-select
              v-model="storeStatus"
              class="serch_input"
              placeholder="门店状态"
              size="mini"
              @change="changeStoreStatus"
            >
            <el-option
                v-for="item in optionsStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="dialog_right_content">
            <div v-if="storeData.length > 0" class="dialog_right_content_box">
              <div class="store_item" @click="selectStoreItem(item)" v-for="(item,index) in storeData" :key="index">
                {{ item.name }}
                <i v-if="item.id === selectStoreId" class="el-icon-success select_icon"></i>
              </div>
            </div>
            <div v-else class="dialog_right_content_empty">
              无数据，请切换条件查询！
            </div>
          </div>
        </div>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-collapse accordion>
          <el-collapse-item title="所选门店">
            <div class="footer_name flex-wrap">
              <el-tag
                :disable-transitions="false"
                closable
                @close="handleClose()"
              >
                <span>
                  <span class="el-select__tags-text">{{selectStoreName}}</span>
                </span>
              </el-tag>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="footer_button">
          <el-button @click="changeSure">确定</el-button>
          <el-button @click="changeCancel" plain>取消</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { each, cloneDeep } from 'lodash';
import * as Api from "../../../common/report.api"

export default {
  props: {
  },
  components: {},
  data() {
    return {
      storeName: '',
      visible: false,
      defaultStaff: [],
      defaultProps: {
        children: 'subList',
        label: 'name',
      },
      areaTreeData: [],
      storeData: [],
      selectNodeId: 1,
      optionsStatus: [
        { label: "门店状态", value: -1 },
        { label: "正常", value: 1 },
        { label: "闭店", value: 0 }
      ], 
      options: [],
      value: [],
      storeStatus: -1,
      input: '',
      storeId: '',
      loading: false,
      selectStoreName: '',
      selectStoreId: ''
    }
  },
  watch: {},
  created() {
    this.initStoreData()
    const firstData = this.storeData[0] || {}
    this.storeName = firstData.name
    this.storeId = firstData.id
    this.selectStoreName = firstData.name
    this.selectStoreId = firstData.id
    this.$emit('update:value', this.selectStoreId)
    this.options = JSON.parse(localStorage.getItem("storeType"))
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 选择区域
    selectArea(data) {
      this.selectNodeId = data.id
      this.getStoreList()
    },
    initStoreData() {
      let allData = JSON.parse(localStorage.getItem('treeStore')) || []
      let allAreaList = cloneDeep(allData)
      each(allAreaList, item => {
        this.getAreaList(item)
      })
      this.areaTreeData = allAreaList
      this.storeData = _.sortBy(this.storeData, 'id')
    },
    getAreaList(itemData) {
      let subList = []
      each(itemData.subList, item => {
        if(item.type === 2){
          this.storeData.push(item)
        }else if(item.type === 1){
          subList.push(item)
          this.getAreaList(item)
        }
      })
      if(subList.length > 0){
        itemData.subList = subList
      }else{
        itemData.subList = undefined
      }
    },
    getStoreList(){
      this.loading = true
      Api.getStore({
        orgId: this.selectNodeId,
        storeTypes: this.value,
        storeName: this.input,
        storeStatus: this.storeStatus === -1 ? undefined : this.storeStatus,

      }).then(res => {
        this.loading = false
        if(res.status === 200 && res.data && res.data.errorCode ===  0){
          this.storeData = []
          this.getAreaList(res.data.data)
        }
      })
    },
    // 选中store数据
    selectStoreItem(item){
      this.selectStoreName = item.name
      this.selectStoreId = item.id
    },
    selectStore() {
      this.selectStoreName = this.storeName
      this.selectStoreId = this.storeId
      this.visible = true
    },
    showEmplist() {
      this.getStoreList()
    },
    changeCancel() {
      this.visible = false
    },
    handleClose(){
      this.selectStoreName = ''
      this.selectStoreId = ''
    },
    changeSure(){
      if(!this.selectStoreName){
        return this.$message.error('请选择门店')
      }
      this.storeName = this.selectStoreName
      this.storeId = this.selectStoreId
      this.$emit('update:value', this.selectStoreId)
      this.visible = false
    },
    changeType(val){
      this.getStoreList()
    },
    changeStoreStatus(val){
      this.getStoreList()
    },
    changeSearch(){
      this.getStoreList()
    }
  },
}
</script>
<style lang="less" scoped>
.store_one {
  &_btn {
    height: 26px;
    line-height: 26px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    color: #3b86ff;
    padding: 0 20px;
    cursor: pointer;
  }
}
.custom-tree-node.selected{
  color: #3b86ff;
  font-weight: 500;
}
.store_one_dialog {
  .dialog {
    display: flex;
    justify-content: space-between;
    height: 100%;
  }
  .dialog_left {
    width: 300px;
    height: 100%;
    overflow: auto;
    padding: 0 10px 10px 10px;
    border-right: 1px solid #dcdfe6;
    box-sizing: border-box;
    &_header{
      display: flex;
      align-items: center;
      &_input{
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        /deep/ .el-input__suffix{
          height: 27px;
          position: absolute;
          right: 0;
          top: 4px;
        }
      }
    }
    &_content{
      height: calc(100% - 60px);
      overflow-y: auto;
      margin-top: 12px;
    }
  }
  .dialog_right {
    width: calc(100% - 320px);
    height: 100%;
    overflow: auto;
    &_header{
      padding: 10px 0;
    }
    &_content{
      height: calc(100% - 60px);
      overflow-y: auto;
      width: 100%;
      &_empty{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #aaa;
      }
      &_box{
        display: flex;
        flex-wrap: wrap;
      }
    }
    .store_item{
      width: 140px;
      height: 45px;
      line-height: 45px;
      box-sizing: border-box;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      margin-right: 12px;
      margin-bottom: 12px;
      position: relative;
      .select_icon{
        color: #3b86ff;
        position: absolute;
        right: 6px;
        top: 6px;
        font-size: 16px;
      }
    }
  }
  /deep/ .el-collapse{
    padding: 0 12px;
  }
  .footer_button{
    text-align: right;
    margin-right: 12px;
  }
}
</style>
